import gql from "graphql-tag";
export const SEARCH_MUTATION = gql`
  mutation search($start: Date!, $end: Date!,
           $rooms:[RoomInput!]!,
           $lon: String, $lat: String,
           $radius: Int) {
  search(input:{
    start: $start
    end: $end
    lon: $lon
    lat: $lat
    radius: $radius
    rooms: $rooms
    
  }){
    token
  }
}
`;
export const BOOK_MUTATION = gql`
  mutation book( $start: Date!, 
            $end: Date!,
            $optionId: String!,
            $paxNames:[PaxNameInput!]!) {
  book(input:{
    start: $start
    end: $end
    optionId: $optionId
    paxNames: $paxNames
  }){
    token
  }
}
`;
export const CANCEL_MUTATION = gql`
  mutation cancel($token: String!){
  cancelBooking(input:{
    token: $token
  }){
    status
    cancelled
  }
}
`;
export const BOOKING_QUERY = gql`
query booking($token:String){
  rezGraphBookingDetails: getBooking(input:{
    token: $token
  }){
    id
    start
    end
    completed
    cancelled
    description
    deposit
    pimRef
    price
    
  }
}
`;
export const SEARCH_RESULTS_QUERY = gql`
query getSearchResult($token: ID!){
  searchResult: getSearchResult(input:{
    token: $token
  }){
  	items {
      id
      start
      end
      pimRef
      pimName
      price
      name
      rooms{
        adults
        children {age}
      }
      
    }
  }
}
`;
export const SEARCH_RESULTS_SUBSCRIPTION = gql`
subscription searchResult($token: ID!) {
  searchResult(input:{
    token: $token
  }){
    items{
      id
      start
      end
      pimRef
      pimName
      price
      name
      rooms{
        adults
        children {age}
      }
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/constants/rezGraphQL.js